import { ProjectTour } from '@/domain/project-tour/entities/project-tour.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Result = ProjectTour;

export const getProjectTour = createAppAsyncThunk(
  'projectTour/getProjectTour',
  async (
    id: number,
    { extra: { projectTourGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const project = await projectTourGateway.get(id);
      return project;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetProject.Message.error'));
}
